var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_w mar_auto"},[_c('br'),_c('br'),_c('div',{staticClass:"flex_align"},[_c('div',{staticClass:"rectangle_icon bgcolor_main"}),_c('div',{staticClass:"m-l-10 f-24 font_weight fa-s"},[_vm._v("演讲比赛结果公示")])]),_c('br'),_c('div',{staticClass:"p-l-10 p-b-10 border_bottom color_888"},[_vm._v("比赛时间：2023年3月9日")]),_c('div',[_c('div')])])
}]

export { render, staticRenderFns }